/**
 * ReseÃ±as â€” revela el tÃ­tulo y las tarjetas con un fundido hacia arriba
 * al hacer scroll, y controla las flechas del slider.
 */
(function () {
  'use strict';

  function initReveal(section) {
    if (!section.classList.contains('rv-barber--reveal')) return;

    var targets = section.querySelectorAll('[data-rv-line], [data-rv-card]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSlider(section) {
    var track = section.querySelector('[data-rv-track]');
    var prevBtn = section.querySelector('[data-rv-prev]');
    var nextBtn = section.querySelector('[data-rv-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function step() {
      var card = track.querySelector('.rv-card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initReviews(section) {
    if (!section || section.dataset.rvInitDone === 'true') return;
    section.dataset.rvInitDone = 'true';

    initReveal(section);
    initSlider(section);
  }

  function initAll() {
    document.querySelectorAll('[data-rv-barber]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-rv-barber]');
    if (section) {
      section.dataset.rvInitDone = 'false';
      initReviews(section);
    }
  });
})();